import axios from 'axios';

export default {
  namespaced: true,

  state: {
    workers: [],
    updated: false
  },

  getters: {
    getWorkers(state) {
      return state.workers;
    },
    getUpdated(state) {
      return state.updated;
    }
  },

  mutations: {
    SET_UPDATED(state, value) {
      state.updated = value;
    }
  },

  actions: {
    async updateMainData({ commit }, data) {
      commit('SET_UPDATED', false);
      const result = {};
      await axios
        .put('/api/workers/' + data.worker_id, {
          user: data.user_data,
          worker: data.worker_data,
          institutions: data.institutions,
          district_administrations: data.district_administrations
        })
        .then(res => {
          result.s = res.data.data;
          commit('SET_UPDATED', true);
        })
        .catch(err => {
          result.e = true;
          if (err.response.data.errors) {
            result.e = err.response.data.errors;
          }
        });
      return result;
    },
    async updateOtherData({ commit }, data) {
      commit('SET_UPDATED', false);
      const result = {};
      await axios
        .put('/api/workers/' + data.worker_id + '/edit-data', {
          user: data.user_data,
          worker: data.worker_data
        })
        .then(res => {
          result.s = res.data.data;
          commit('SET_UPDATED', true);
        })
        .catch(err => {
          result.e = true;
          if (err.response.data.errors) {
            result.e = err.response.data.errors;
          }
        });
      return result;
    }
  }
};
